import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { FileDownloadRounded } from '@mui/icons-material'
import { SPACING } from '@common/theme/spacing'

export type DownloadOnlyViewerProps = {
  fileName?: string | null
  fileExtension?: string | null
  isDownloading: boolean
  onDownload: () => void
}

export default function DownloadOnlyViewer({
  fileName,
  fileExtension,
  isDownloading,
  onDownload,
}: DownloadOnlyViewerProps) {
  const format = fileExtension?.toUpperCase()

  return (
    <Stack
      flex={1}
      alignItems="center"
      justifyContent="center"
      spacing={SPACING.spacingLg}
      data-testid="non-dicom-download-only-viewer"
    >
      <Stack alignItems="center" spacing={SPACING.spacingSm}>
        <Typography color="text.primary" variant="subtitle2">
          {format ? `${format} files cannot be previewed in the application` : 'This file cannot be previewed'}
        </Typography>
        <Typography color="text.secondary" variant="body2">
          {fileName || 'Download the file to view it.'}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        onClick={onDownload}
        disabled={isDownloading}
        startIcon={isDownloading ? <CircularProgress size={16} color="inherit" /> : <FileDownloadRounded />}
      >
        Download
      </Button>
    </Stack>
  )
}
